<template>
  <div class="box" ref="screenDom">
    <scale-box :width="1920" :height="1080" bgc="transparent" :delay="100" style="transition: unset;"
               @scaleChange="handleScaleChange">
      <router-view/>
    </scale-box>
  </div>
</template>

<script>
import ScaleBox from "vue2-scale-box";

export default {
  components: {
    ScaleBox
  },
  mounted() {
    // this.resizeFn()
    // window.addEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      let scale = window.innerWidth / 1920;
      if (this.$refs.screenDom) {
        this.$refs.screenDom.style.transform = `scale(${scale})`
      }
    },
    handleScaleChange(val) {
      console.log('缩放值发生改变', val)
      this.$store.commit('setScale', val)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  // width: 1920px;
  // height: 1080px;
  // transform-origin: 0 0;
  // background: #111E23;
  width: 100%;
  height: 100%;
}
</style>
